export type SingleFlight<V> = {
  run: (key: string, factory: () => Promise<V>) => Promise<V>;
  clear: () => void;
};

// gloss
export const createSingleFlight = <V>(): SingleFlight<V> => {
  const inFlight = new Map<string, Promise<V>>();

  const run = (key: string, factory: () => Promise<V>): Promise<V> => {
    const pending = inFlight.get(key);
    if (pending) return pending;

    const flight: Promise<V> = factory().finally(() => {
      if (inFlight.get(key) === flight) inFlight.delete(key);
    });
    inFlight.set(key, flight);

    return flight;
  };

  return {
    run,
    clear: () => inFlight.clear(),
  };
};
